module.exports = __webpack_public_path__ + "img/migration-service-s.d4fb9790.png";